import { Box, useTheme } from "@mui/material";
import React from "react";
import { Lock as LockIcon } from "@mui/icons-material";
import CustomTypography from "../form/CustomTypography";

export interface PermissionBlockLabelProps {
  title?: string;
}

const PermissionBlockLabel = (props: PermissionBlockLabelProps) => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        padding: { xs: 4, sm: 6 },
        minHeight: "300px",
        width: "100%",
        background: `linear-gradient(135deg, ${
          theme.palette.customColors?.white || "#ffffff"
        } 0%, ${theme.palette.customColors?.lightGreyColor || "#f5f5f5"} 100%)`,
        borderRadius: "16px",
        border: `1px solid ${
          theme.palette.customColors?.greyBorder || "#e0e0e0"
        }`,
        boxShadow: "0 4px 12px rgba(0, 0, 0, 0.08)",
        position: "relative",
        "&::before": {
          content: '""',
          position: "absolute",
          top: 0,
          left: 0,
          right: 0,
          height: "4px",
          background: `linear-gradient(90deg, ${
            theme.palette.customColors?.blueGradientStart || "#6455ED"
          } 0%, ${
            theme.palette.customColors?.blueGradientEnd || "#8B7DFF"
          } 50%, ${
            theme.palette.customColors?.blueGradientStart || "#6455ED"
          } 100%)`,
          borderRadius: "16px 16px 0 0",
        },
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: 2,
          maxWidth: "500px",
        }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            width: "80px",
            height: "80px",
            borderRadius: "50%",
            backgroundColor:
              theme.palette.customColors?.lightGreyColor || "#f5f5f5",
            border: `2px solid ${
              theme.palette.customColors?.greyBorder || "#e0e0e0"
            }`,
            boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
            marginBottom: 1,
          }}
        >
          <LockIcon
            sx={{
              fontSize: "40px",
              color: theme.palette.customColors?.greyTextColor || "#757575",
            }}
          />
        </Box>
        <CustomTypography
          variant="heading3"
          style={{
            fontWeight: 600,
            textAlign: "center",
            color: theme.palette.customColors?.blackBorder || "#212121",
            marginBottom: 1,
          }}
        >
          Access Restricted
        </CustomTypography>
        <CustomTypography
          variant="body2"
          style={{
            textAlign: "center",
            color: theme.palette.customColors?.greyTextColor || "#757575",
            lineHeight: "1.6",
            fontSize: "1.1rem",
          }}
        >
          {props.title || "You do not have permission to view this section."}
        </CustomTypography>
      </Box>
    </Box>
  );
};

export default React.memo(PermissionBlockLabel);
